import React, { useState } from 'react';
import { MoreVertical } from 'react-feather';
import { format, parseISO } from 'date-fns';
import { useHistory } from 'react-router';
import { PAGES, ROUTE_PATHS } from '../../../InternalApiApp';
import ProfileImage from '../../ProfileImage';
import FlexWrapper from '../../../layouts/FlexWrapper';
import Tooltip from '../../popups/Tooltip';
import "./NotificationMenuItem.scss"

const CommentNotificationContent = ({ notification, noComment, action, markAsRead, setActiveNotification, systemMessage }) => {
	const { content, createdAt, senderName, readAt, icon, subject } = notification
	const [moving, setMoving] = useState(false)
	const history = useHistory()

	if (!notification) {
		console.log("no notification DTO provided")
		return null
	}

	function onClick(ntf) {
		if (ntf.actionType === 'RESTART_DATA_UPLOAD') {
			history.push(`${ROUTE_PATHS[PAGES.DATA_MANAGEMENT]}`)
		} else {
			setActiveNotification(ntf)
			if (ntf.requestId) history.push(`${ROUTE_PATHS[PAGES.REQUESTS]}/${ntf.requestId}`)
		}
		markAsRead(ntf.notificationReceiverId)
	}

	function toolTipClick(e) {
		e.stopPropagation()
		e.preventDefault()
		const id = notification?.notificationMsgReceiverId || notification?.notificationReceiverId
		markAsRead(id, readAt ? true : false)
	}

	function getActionClassName(action) {
		if (action) {
			const actionClassName = "notification-action"
			if (action === 'approved') return actionClassName + " approved"
			else if (action === 'rejected') return actionClassName + " rejected"
			else return ""
		} else return ""
	}

	return (<>
		<FlexWrapper
			className={`notification-menu-item-wrapper${readAt ? "" : " unread"}${moving ? ' hovering' : ""}`}
			onClick={(e) => { e.preventDefault(); onClick(notification) }}
			align="start"
			gap="s"
			onMouseEnter={() => setMoving(true)}
			onMouseLeave={() => setMoving(false)}
		>

			{senderName && <ProfileImage user={{ name: senderName }} />}
			{!senderName && systemMessage && <ProfileImage user={{ name: "3 Skye" }} />}
			{icon && <div className="notification-menu-item-icon-wrapper">{icon}</div>}
			<FlexWrapper direction="column" gap="s" align="start">
				<div className='notification-menu-item-label-wrapper'>
					<p className='notification-menu-item-label'><span className='font-weight-semi-bold'>{senderName}</span><span className={getActionClassName(action)}>{action ? " " + action + " " : " "}</span><span className='font-weight-semi-bold'>{subject}</span></p>
					<Tooltip label={<div onClick={toolTipClick} className='mark-as-read-popup' style={{ padding: '0.75rem' }}>{readAt ? 'Mark as unread' : 'Mark as read'}</div>} placement='bottom-end' innerStyle={{ fontSize: '0.85rem', cursor: 'pointer', padding: '0.25rem 0' }} >
						<MoreVertical className={`mark-as-read-icon${moving ? ' show' : ''}`} />
					</Tooltip>
				</div>
				{!noComment &&
					<div className="comment-notification-message" >
						{action === 'rejected' ? notification.commentDto.comment : content}
					</div>
				}
				{createdAt && <div className="notification-menu-item-sub-label" style={{ opacity: 0.5, fontWeight: 500 }}>{format(parseISO(createdAt), "h:mm aa, dd MMM yyyy")}</div>}
			</FlexWrapper>
		</FlexWrapper>
	</>);
}

export default CommentNotificationContent;